import Enumerable from "linq";
import { DateRangeType, DurationTimeframeTypeEnum, OptionalColumnEnum, SortOrder, Style, TimeframeType, UsageType } from "../../enums/DRCXEnums";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
import { DRCXAvailableOptionalColumn } from "./DRCXAvailableOptionalColumn";
import { IDRCXConfigurationSectionDTO } from "./DRCXConfigurationSectionDTO";
import { DRCXConfigurationSectionModelBase } from "./DRCXConfigurationSectionModelBase";

export class DRCXConfigurationSectionModel extends DRCXConfigurationSectionModelBase {

    public dataType: eLynxObjectTypeEnum = eLynxObjectTypeEnum.Device;
    //public style4Timeframe: TimeframeType | undefined = TimeframeType.Daily;

    // public previousStyle: Style = this.style;
    // public previousStyle4Timeframe: TimeframeType | undefined = this.style4Timeframe;
    // public previousFixedStartDate: Date | undefined = this.fixedStartDate ? new Date(this.fixedStartDate) : undefined;
    // public previousFixedEndDate: Date | undefined = this.fixedEndDate ? new Date(this.fixedEndDate) : undefined;

    // UI use only
    //public lastDataType = this.dataType;
    
    public constructor(dto?: IDRCXConfigurationSectionDTO) {
        super(dto);

        if (dto) {
            if (typeof dto.dataType !== "undefined") {
                this.dataType = dto.dataType;
                //this.lastDataType = dto.dataType;
            }
        }

        if (this.style === Style.Pivot_Object_TAT) {
            const tatColumn = Enumerable
                .from(this.tatColumns)
                .firstOrDefault(column => column.groupingTimeframe === TimeframeType.Hourly ||
                    column.groupingTimeframe === TimeframeType.Daily ||
                    column.groupingTimeframe === TimeframeType.Monthly);

            if (tatColumn) {
                //this.style4Timeframe = tatColumn.groupingTimeframe;
                //this.previousStyle4Timeframe = tatColumn.groupingTimeframe;
            }
        }

        //section.rawDataClosenessMin > 0 || section.rawDataClosenessSec > 0

    }

    public clone(): DRCXConfigurationSectionModel {
        const model = new DRCXConfigurationSectionModel(this.toDTO());
        // model.isExpanded = this.isExpanded;
        // model.isValid = this.isValid;
        // model.isRawDataCloseness = this.isRawDataCloseness;

        // model.previousStyle = this.previousStyle;

        //model.style4Timeframe = this.style4Timeframe;
        // model.previousStyle4Timeframe = this.previousStyle4Timeframe;

        // model.previousFixedStartDate = this.previousFixedStartDate ? new Date(this.previousFixedStartDate) : undefined;
        // model.previousFixedEndDate = this.previousFixedEndDate ? new Date(this.previousFixedEndDate) : undefined;

        return model;
    }
    
    public /*override*/ hasDeprecatedFeatures(): boolean {
        // Has deprecated features if:
        // 1. includeTanks is set
        // 2. Has at least one group object with targetObjectType == Device and at least
        //    one group object with targetObjectType == Tank
        // 3. Has at least one device object and at least one tank object
        return this.includeTanks || (this.hasDevices && this.hasTanks);
    }

    protected _toDTO(dto: IDRCXConfigurationSectionDTO): IDRCXConfigurationSectionDTO {
        super._toDTO(dto);
        dto.dataType = this.dataType;
        return dto;
    }

    public static createDefault(order: number, optionalColumns: Enumerable.ILookup<string, DRCXAvailableOptionalColumn>): DRCXConfigurationSectionModel {
        const defaultStyle = Style.Pivot_Object_Timeframe;
        const defaultDataType = eLynxObjectTypeEnum.Device;
        const columns = DRCXConfigurationSectionModel.getDefaultOptionalColumns(optionalColumns, defaultStyle, defaultDataType);
        const section = new DRCXConfigurationSectionModel({
            name: `New Section ${order}`,
            order: order,
            style: defaultStyle,
            dateSortOrder: SortOrder.Ascending,
            deviceSortOrder: SortOrder.Ascending,
            deviceSortColumn: OptionalColumnEnum.DeviceDisplayName,
            timeframe: {
                durationTimeframeType: DurationTimeframeTypeEnum.MultipleTimeFrames,
                calculatedStartDateOffset: {
                    // Use a negate formatter
                    duration: -6,
                    rangeType: DateRangeType.Day
                },
                duration: {
                    duration: 7,
                    rangeType: DateRangeType.Day
                }
            },
            dataType: defaultDataType
        });
    
        // Add all default and required optional columns
        columns.forEach(column => {
            section.addColumn(column.displayText,
                column.equatableKey,
                //false,
                column.usageType === UsageType.Default,
                column.usageType === UsageType.Required
            );
        });
    
        return section;
    }

    public static getDefaultOptionalColumns(
        optionalColumns: Enumerable.ILookup<string, DRCXAvailableOptionalColumn>,
        style: Style,
        dataType: eLynxObjectTypeEnum
    ): Array<DRCXAvailableOptionalColumn> {
        const lookupKey: string = DRCXAvailableOptionalColumn.getLookupKey(style, dataType);
        return optionalColumns
            .get(lookupKey)
            .where(oc => oc.usageType === UsageType.Default ||
                oc.usageType === UsageType.Required)
            .orderBy(oc => oc.defaultOrder)
            .toArray();
    }
}



    // public /*override*/ addObject(name: string, equatableKey: string, deviceType?: DeviceTypesEnum, ruleType?: RulesEngineRuleTypeEnum): void {
    //     if (!Enumerable.from(this.objects).any((obj: DRCXConfigurationSectionObjectModel) => obj.equatableKey === equatableKey)) {
    //         const object: DRCXConfigurationSectionObjectModel = new DRCXConfigurationSectionObjectModel({
    //             name: name,
    //             order: this.objects.length,
    //             deviceType: deviceType,
    //             ruleType: ruleType
    //         });
    //         object.equatableKey = equatableKey;
    //         if (object.objectType === eLynxObjectTypeEnum.Group) {
    //             object.targetObjectType = this.dataType;
    //         } else {
    //             object.targetObjectType = object.objectType;
    //         }
    //         this.objects.push(object);
    //     }
    // }

    // public /*override*/ validate(): boolean {
    //     // Must have a valid name, contain at least one TAT column, and contain at least one object (group/device/tank)
    //     this.isValid = typeof this.name === "string" &&
    //         this.columns &&
    //         Enumerable.from(this.columns).any(c => c.columnType === ColumnType.Tat ||
    //             c.columnType === ColumnType.TatType ||
    //             c.columnType === ColumnType.Event) &&
    //         this.objects &&
    //         this.objects.length > 0;
    //     return this.isValid;
    // }

